<template>
  <div class="d-flex align-items-center">
    <!-- CENTER: Middle Menu (desktop only) -->
    <ul v-if="showMiddleMenu" class="nav navbar-nav align-items-center d-none d-md-inline-flex middle-menu">
      <li class="nav-item">
        <router-link :to="{name: 'profile'}" class="nav-link nav-link-style d-flex btn btn-outline-secondary p-10">
          <i class="fas fa-home mb-0 mr-5"></i>
          <span class="h5 d-sm-none d-xl-inline-block m-0">Home</span>
        </router-link>
      </li>
      <li class="nav-item ms-3">
        <router-link :to="{name: 'Proadvisor'}" class="nav-link nav-link-style d-flex btn btn-outline-secondary p-10">
          <i class="fas fa-chalkboard-teacher mb-0 mr-5"></i>
          <span class="h5 d-sm-none d-xl-inline-block m-0">Pro Adviser</span>
        </router-link>
      </li>
      <li class="nav-item ms-3">
        <router-link :to="{name: 'contact.user.index'}" class="nav-link nav-link-style d-flex btn btn-outline-secondary p-10">
          <i class="fas fa-address-book mb-0 mr-5"></i>
          <span class="h5 d-sm-none d-xl-inline-block m-0">My Contacts</span>
        </router-link>
      </li>
    </ul>

    <!-- Mobile middle-menu dropdown -->
    <li v-if="showProfileMenu" class="nav-item dropdown d-inline d-md-none nav-icon-item">
      <a id="dropdown-menu" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link nav-icon-link">
        <img src="/app-assets/images/icons/layout/menu.svg" width="18" height="18" alt="Menu">
      </a>
      <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdown-menu">
        <router-link to="/home" class="dropdown-item">
          <i class="fas fa-home mb-0 h5 me-2"></i> Profile
        </router-link>
        <router-link :to="{name: 'Proadvisor'}" class="dropdown-item">
          <i class="fas fa-chalkboard-teacher mb-0 h5 me-2"></i> ProAdvisor
        </router-link>
        <router-link :to="{name: 'contact.user.index'}" class="dropdown-item">
          <i class="fas fa-address-book mb-0 h5 me-2"></i> My Contacts
        </router-link>
        <template v-if="modules && modules.length">
          <div class="dropdown-divider"></div>
          <div v-for="(item, i) in modules" :key="i">
            <a class="dropdown-item d-flex align-items-center" :href="getModuleUrl(companyId, item)">
              <img :src="item.icon" width="20" class="me-2" alt=""/> {{ item.name }}
            </a>
          </div>
        </template>
      </div>
    </li>
  </div>
</template>

<script>
import handleSidebar from "@/services/modules/sidebar";

export default {
  name: 'NavbarMiddle',
  props: {
    showMiddleMenu: {
      type: Boolean,
      default: false
    },
    showProfileMenu: {
      type: Boolean,
      default: false
    },
    modules: {
      type: Array,
      default: () => []
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  setup() {
    const { getModuleUrl } = handleSidebar();
    return { getModuleUrl };
  }
};
</script>

<style scoped>
.middle-menu .nav-link.btn-outline-secondary { border: none !important; transition: background 0.15s; }
.middle-menu .nav-link.btn-outline-secondary:hover { background-color: rgba(0,0,0,0.07) !important; }
.middle-menu .nav-link span { margin-left: 0.4rem; }

.nav-icon-item { display: flex; align-items: center; }
.nav-icon-link {
  display: flex; align-items: center; justify-content: center;
  width: 38px; height: 38px;
  padding: 0 !important;
  border-radius: 10px;
  color: #6366f1;
  background-color: transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 575.98px) {
  .nav-icon-link { width: 34px; height: 34px; border-radius: 8px; }
}
@media (max-width: 359.98px) {
  .nav-icon-link { width: 28px; height: 28px; }
}
</style>
